import React from 'react';

import  DialogContent from '@mui/material/DialogContent'
import  Typography from '@mui/material/Typography'
import  Divider from '@mui/material/Divider'
import  Dialog from '@mui/material/Dialog'
import  DialogActions from '@mui/material/DialogActions'
import  Button from '@mui/material/Button'
import  DialogTitle from '@mui/material/DialogTitle'
import  Box from '@mui/material/Box'

import AudioInputList from './AudioInputList'
import AudioOutputList from './AudioOutputList'
import VideoInputList from './VideoInputList'
import { useStyles } from './styles'

export default function DeviceSelectionDialog({ 
  open, 
  onClose 
}: { 
  open: boolean; 
  onClose: () => void 
}) {
  const styles = useStyles();

  return (
    <Dialog 
      open={open} 
      onClose={onClose} >
      <DialogTitle>Audio and Video Settings</DialogTitle>
      <Divider />
      <DialogContent 
        sx={styles.container} >
        <Box sx={styles.listSection}>
          <Typography 
            variant="h6" 
            sx={styles.headline} >
            Video
          </Typography>
          <VideoInputList />
        </Box>
        <Divider />
        <Box sx={styles.listSection}>
          <Typography 
            variant="h6" 
            sx={styles.headline} >
            Audio
          </Typography>
          <AudioInputList />
        </Box>
        <Box 
          sx={styles.listSection} >
          <AudioOutputList />
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button 
          color="primary" 
          variant="contained" 
          sx={styles.button} 
          onClick={onClose}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  )
}
